import PropTypes from "prop-types";

/**
 * The prop shape of a provisioned subscription as the hooks return it.
 */
export const provisionedSubscriptionShape = PropTypes.shape( {
	id: PropTypes.string.isRequired,
	subscriptionNumber: PropTypes.string,
	customerEmail: PropTypes.string,
	product: PropTypes.shape( {
		code: PropTypes.string,
		name: PropTypes.string,
	} ),
	siteUrl: PropTypes.string,
	status: PropTypes.string,
	startDate: PropTypes.instanceOf( Date ),
	endDate: PropTypes.instanceOf( Date ),
	pluginDownloadUrls: PropTypes.arrayOf( PropTypes.string ),
} );
